import { render, staticRenderFns } from "./CrearDistribuidor.vue?vue&type=template&id=7c808d2c"
import script from "./CrearDistribuidor.vue?vue&type=script&lang=js"
export * from "./CrearDistribuidor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports